// Utility per estrarre un messaggio d'errore SICURO (stringa) da una risposta axios.
// Il backend può restituire `detail` come: stringa, oggetto {code, message},
// oppure array di errori di validazione FastAPI. Non passare MAI un oggetto a toast.error
// (React lancia "Objects are not valid as a React child" e la pagina diventa bianca).
export function getErrorMessage(error, fallback = 'Si è verificato un errore') {
  const detail = error?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) return detail;

  // FastAPI validation errors: array di { loc, msg, type }
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => (typeof d === 'string' ? d : d?.msg))
      .filter(Boolean);
    if (msgs.length) return msgs.join(' · ');
  }

  // Errore strutturato { code, message }
  if (detail && typeof detail === 'object') {
    if (typeof detail.message === 'string' && detail.message.trim()) return detail.message;
    if (typeof detail.msg === 'string' && detail.msg.trim()) return detail.msg;
  }

  if (typeof error?.message === 'string' && error.message.trim()) return error.message;
  return fallback;
}
